
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/[id]",
      function () {
        return require("private-next-pages/cases/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cases/[id]"])
      });
    }
  